import React from 'react';

import { DefaultComponentProps } from '../../types';

import { CardHeader } from '../CardHeader';

import './style.scss';

export const Spinner = ({ textConfig }: DefaultComponentProps) => {
  return (
  <>
    <CardHeader title={''} ingress={textConfig.spinner.pleaseWait} />
    <div className="spinner" />
  </>
  );
};
